import ArticleInterface from '@app/Interface/ArticleInterface';
import { Card, CardTitle, CardBody, CardFooter } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';

interface LatestArticleItemProps {
    article: ArticleInterface,
    path: string,
    pageId: number
}

const LatestArticleItem: React.FC<LatestArticleItemProps> = ({ article, path, pageId }) => {

    return (
        <Card key={article.id} id={`latest-aritcle-card-${article.id}`} isFlat isCompact>
            <CardTitle>{article.date.toDateString()}</CardTitle>
            <CardBody>
                {article.title}
            </CardBody>
            <CardFooter>
                <Link to={{ pathname: path, search: `?article=${article.slug}`, state: { pageId: pageId } }}>Read more &gt;</Link>
            </CardFooter>
        </Card>
    );

}

export default LatestArticleItem